import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider/FeatureFlagProvider"
import { AppContext } from "../../../../mp-core/context"
import { RootState } from "../../../../mp-core/redux/store/index"
import { NavItem } from "../../../types/index"
import {
  getAvailableNavItemsUnderFeatureFlagAndLicense,
  getRedirectPath
} from "../helpers"
import { LicensesSet } from "../../../../mp-database"
import { ProgramsContext } from "../../../../mp-shared-components/ready-shared-components/components/Navs"

export const useNavItemsUnderFeatureFlagAndLicense = (
  navItem: NavItem,
  defaultPath = "/reporting"
) => {
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)
  const { state: appState } = useContext(AppContext)
  const { programsAndCourses } = useContext(ProgramsContext)

  const { user, userLicenses } = useSelector((state: RootState) => ({
    user: state.users.testUser,
    userLicenses: state.licenses.userlicenses as LicensesSet[]
  }))

  // Get isACTDistrict from AppContext district data
  const isACTDistrict = appState?.district?.record?.isACTDistrict || false

  const availablePrograms = useMemo(
    () => programsAndCourses.map(p => p.program),
    [programsAndCourses]
  )

  const moduleNavItems: NavItem[] = useMemo(() => {
    if (featureFlagsLoading) return null

    const filteredNavItems = getAvailableNavItemsUnderFeatureFlagAndLicense(
      navItem,
      featureFlags,
      userLicenses,
      isACTDistrict,
      user?.role,
      availablePrograms
    )

    return !!filteredNavItems ? [filteredNavItems] : []
  }, [
    featureFlags,
    featureFlagsLoading,
    userLicenses,
    isACTDistrict,
    user?.role,
    availablePrograms
  ])

  const getRedirectPathForRoute = getRedirectPath(
    moduleNavItems?.[0],
    user.role,
    defaultPath
  )

  return { moduleNavItems, getRedirectPathForRoute }
}
